const lbTooltip = angular.module('app.lbTooltip', []);

lbTooltip.controller('lbTooltipController', require('./lbTooltipController'));
lbTooltip.directive('lbTooltip', require('./lbTooltipDirective'));

export default lbTooltip;



// WEBPACK FOOTER //
// ./src/directives/lbTooltip/index.js